export default "__VITE_ASSET__DouPDtAj__"